import { memo } from 'react';

import AIDocumentIconSVG from '@/assets/ai-document-filled.svg?react';
import { Icon, IconProps } from '@/components/core';

const IAIDocumentIcon = ({ ...rest }: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={AIDocumentIconSVG} {...rest} />
);

export const AIDocumentIcon = memo(IAIDocumentIcon) as typeof IAIDocumentIcon;
